module.exports = __webpack_public_path__ + "img/eematico-toys-jucarii-racing-kit.5ffeb720.jpg";